/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StripeCardUpdateCompleteRequest } from '../models/StripeCardUpdateCompleteRequest';
import type { StripeCardUpdateInfo } from '../models/StripeCardUpdateInfo';
import type { StripeCardUpdateResult } from '../models/StripeCardUpdateResult';
import type { StripeReaderData } from '../models/StripeReaderData';
import type { StripeReaderPaymentData } from '../models/StripeReaderPaymentData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StripeService {
  /**
   * Get Stripe Card Update
   * @param token
   * @returns StripeCardUpdateInfo Successful Response
   * @throws ApiError
   */
  public static getStripeCardUpdate(token: string): CancelablePromise<StripeCardUpdateInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/stripe/card_update',
      query: {
        token: token,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Complete Stripe Card Update
   * @param requestBody
   * @returns StripeCardUpdateResult Successful Response
   * @throws ApiError
   */
  public static completeStripeCardUpdate(
    requestBody: StripeCardUpdateCompleteRequest,
  ): CancelablePromise<StripeCardUpdateResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/stripe/card_update/complete',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Stripe Readers
   * @returns StripeReaderData Successful Response
   * @throws ApiError
   */
  public static getStripeReaders(): CancelablePromise<Array<StripeReaderData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/stripe/readers',
    });
  }

  /**
   * Get Stripe Reader Payment
   * @param orderId
   * @param lineId
   * @returns StripeReaderPaymentData Successful Response
   * @throws ApiError
   */
  public static getStripeReaderPayment(orderId: string, lineId: string): CancelablePromise<StripeReaderPaymentData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/stripe/reader_payment/{order_id}/{line_id}',
      path: {
        order_id: orderId,
        line_id: lineId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Retry Stripe Reader Payment
   * @param orderId
   * @param lineId
   * @returns StripeReaderPaymentData Successful Response
   * @throws ApiError
   */
  public static retryStripeReaderPayment(orderId: string, lineId: string): CancelablePromise<StripeReaderPaymentData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/stripe/reader_payment/{order_id}/{line_id}/retry',
      path: {
        order_id: orderId,
        line_id: lineId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Cancel Stripe Reader Payment
   * @param orderId
   * @param lineId
   * @returns StripeReaderPaymentData Successful Response
   * @throws ApiError
   */
  public static cancelStripeReaderPayment(orderId: string, lineId: string): CancelablePromise<StripeReaderPaymentData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/stripe/reader_payment/{order_id}/{line_id}/cancel',
      path: {
        order_id: orderId,
        line_id: lineId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
